function hashTourKey(tourId, tourName) {
  const raw = `${tourId ?? ""}:${String(tourName ?? "").trim().toLowerCase()}`;
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash << 5) - hash + raw.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getTourMapColor(tourId, tourName) {
  const hash = hashTourKey(tourId, tourName);
  const hue = hash % 360;
  const saturation = 48 + (hash % 18);
  const lightness = 30 + (hash % 10);
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
